document.addEventListener('DOMContentLoaded', () => {
  const shortcuts = {
    doubleShift: {
      keys: ['Shift'],
      action: () => {
        const searchInput = document.getElementById('quick-search');
        if (searchInput) {
          searchInput.focus();
        }
      },
      delay: 300
    },
    // Add more shortcuts here
  };

  const keyState = {};
  const lastKeyPress = {};

  document.addEventListener('keydown', handleKeyDown);
  document.addEventListener('keyup', handleKeyUp);

  function handleKeyDown(event) {
    keyState[event.key] = true;
  }

  function handleKeyUp(event) {
    keyState[event.key] = false;
    const now = new Date().getTime();

    for (const [shortcutName, shortcut] of Object.entries(shortcuts)) {
      if (shortcut.keys.every(key => keyState[key] === false)) {
        if (shortcut.delay) {
          if (now - (lastKeyPress[shortcutName] || 0) <= shortcut.delay) {
            shortcut.action();
          }
          lastKeyPress[shortcutName] = now;
        } else {
          shortcut.action();
        }
      }
    }
  }
});